<template>
  <button type="button" class="nav-burger" name="navigation button">
    <span
      v-for="element in 3"
      :key="element"
      class="nav-burger__bar"
      :style="burgerButtonStyle"
    />
  </button>
</template>

<script setup lang="ts">
interface Props {
  navbarColor?: string
  isTransparent?: boolean
  buttonsColor?: '#000033' | '#fff'
}
const props = defineProps<Props>()
const { burgerButtonStyle } = useNavbarStyle(
  toRef(props, 'navbarColor'),
  toRef(props, 'isTransparent'),
  toRef(props, 'buttonsColor'),
)
</script>

<style lang="scss" scoped>
.nav-burger {
  display: block;
  position: relative;
  color: inherit;

  &__bar {
    width: 24px;
    height: 2px;
    margin-bottom: 4px;
    display: block;
    background-color: currentColor;
    transition: background-color 0.35s ease;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
